import { render, staticRenderFns } from "./DisposalDetail.vue?vue&type=template&id=113fd0b2"
import script from "./DisposalDetail.vue?vue&type=script&lang=js"
export * from "./DisposalDetail.vue?vue&type=script&lang=js"
import style0 from "./DisposalDetail.vue?vue&type=style&index=0&id=113fd0b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports